import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {DialogComponent} from '@/components/dialog/dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {MaterialModule} from '@/material.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {LogComponent} from '@/components/log/log.component';
import {ProgressComponent} from '@/components/progress/progress.component';
import {AutofocusDirective} from '@/_directives/autofocus.directive';
import {HideMissingImageDirective} from './_directives/hide-missing-image.directive';
import {NgOptimizedImage} from '@angular/common';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import {SiteTactaComponent} from '@/components/site-tacta/site-tacta.component';
import {CloseButtonComponent} from '@/controls/close-button/close-button.component';
import {MainComponent} from '@/components/main/main.component';

export const DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY',   // wie das eingegebene Datum geparst wird
  },
  display: {
    dateInput: 'DD.MM.YYYY',     // wie’s im Input-Feld dargestellt wird
    monthYearLabel: 'MMMM YYYY', // wie der Monats-/Jahresheader aussieht, z. B. „März 2025“
    dateA11yLabel: 'LL',         // für Screen Reader – „LL“ ist oft komplett ausgeschriebenes Datum
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AutofocusDirective,
    AppComponent,
    DialogComponent,
    HideMissingImageDirective,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    FormsModule,
    MaterialModule,
    DragDropModule,
    LogComponent,
    ProgressComponent,
    NgOptimizedImage,
    ReactiveFormsModule,
    SiteTactaComponent, CloseButtonComponent, MainComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideMomentDateAdapter(DATE_FORMAT),]
})
export class AppModule {
}
